import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack } from '@mui/material';

import { useRouter } from '@cvt/routing';
import { useDictionary } from '@cvt/hooks/useDictionary';
import { Step } from '@modules/Dashboard/components/Box/Step';



export const Steps = () => {
  const router = useRouter();
  const dictionary = useDictionary();

  return (
    <Stack mt={8} direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 3, md: 4 }}>
      <Step
        title={dictionary.dashboard.steps.defineGoals.title}
        subtitle={dictionary.dashboard.steps.defineGoals.subtitle}
        description={dictionary.dashboard.steps.defineGoals.description}
      >
        <Button component={RouterLink} to={router.objectives.path} color="primaryAlt" variant="contained">
          {dictionary.dashboard.steps.defineGoals.button}
        </Button>
      </Step>
      <Step
        title={dictionary.dashboard.steps.clarifyValues.title}
        subtitle={dictionary.dashboard.steps.clarifyValues.subtitle}
        description={dictionary.dashboard.steps.clarifyValues.description}
      >
        <Button component={RouterLink} to={router.values.path} color="primaryAlt" variant="contained">
          {dictionary.dashboard.steps.clarifyValues.button}
        </Button>
      </Step>
      <Step
        title={dictionary.dashboard.steps.buildStoryBank.title}
        subtitle={dictionary.dashboard.steps.buildStoryBank.subtitle}
        description={dictionary.dashboard.steps.buildStoryBank.description}
      >
        <Button component={RouterLink} to={router.stories.create.path} color="primaryAlt" variant="contained">
          {dictionary.dashboard.steps.buildStoryBank.button}
        </Button>
      </Step>
    </Stack>
  );
};